kombi.requests = {
    request: function (url, method, headers, body) {
        return fetch(url, {
            method: method.toUpperCase(),
            headers: headers,
            body: body
        })
    },
    postFormJson: async function (url, form, csrfmiddlewaretoken) {
        try {
            if (!form.__disabled) {
                form.__disabled = true
                const postData = new FormData(form)
                const csrfToken = csrfmiddlewaretoken || postData.get('csrfmiddlewaretoken')
                const headers = {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                }
                const response = await this.request(
                    url,
                    'POST',
                    headers,
                    JSON.stringify(Object.fromEntries(postData.entries()))
                ).catch((error) => {
                    console.error("There has been a problem with your fetch operation:", error);
                });

                form.__disabled = false
                return await response.json();
            } else {
                console.info("postFormJson is running, wait", form);
            }
        } catch (error) {
            form.__disabled = false
            console.error("There has been a problem with your postFormJson", error);
        }
    },
    getText: async function (url) {
        try {

            let response = await this.request(url, 'GET')
                .catch((error) => {
                    console.error("There has been a problem with your fetch operation:", error);
                });

            return await response.text();
        } catch (error) {
            console.error("There has been a problem with your getText", error);
        }
    }
}
